__turbopack_context__.v({
  "emptyState": "NewsList-module-scss-module__1HokEa__emptyState",
  "loadMoreButton": "NewsList-module-scss-module__1HokEa__loadMoreButton",
  "loadMoreWrapper": "NewsList-module-scss-module__1HokEa__loadMoreWrapper",
  "loading": "NewsList-module-scss-module__1HokEa__loading",
  "newsGrid": "NewsList-module-scss-module__1HokEa__newsGrid",
  "newsList": "NewsList-module-scss-module__1HokEa__newsList",
});
